import Cookies from 'js-cookie';

export const getCookie = (name: string): string | undefined => {
    return Cookies.get(name);
};

export const setCookie = (name: string, value: string): void => {
    Cookies.set(name, value);
};

export const removeCookie = (name: string): void => {
    Cookies.remove(name);
};
